module.exports = __webpack_public_path__ + "07ae10b9eae236b0c9ec67416b0e55a4.jpg";